import {
  ComponentHealthPlanActionType,
  GeckoMeasurementUnit,
  RolodexEntryType,
} from 'types'

import { ComponentHealthCondition } from './assetHealthPlanning/componentHealthConditions'

export const THICKNESS_UNIT_TO_CORROSION_UNIT = {
  [GeckoMeasurementUnit.Inches.id]: GeckoMeasurementUnit.InchesPerYear,
  [GeckoMeasurementUnit.Millimeters.id]:
    GeckoMeasurementUnit.MillimetersPerYear,
}

export const ENTRY_TYPE_TO_CHP_ACTION_TYPE: Partial<
  Record<RolodexEntryType, ComponentHealthPlanActionType>
> = {
  [RolodexEntryType.DERATING_SCENARIO]: {
    shortName: 'Op Change/Liner',
    longName: 'Operational Changes & Liners',
    description:
      'An addition of a protective liner, or a change in operating parameters (such as fill height), to improve remaining life',
  },
  [RolodexEntryType.REPAIR_PLAN]: {
    shortName: 'Repair',
    longName: 'Repair Plan',
    description: 'A plan to repair the asset in sections',
  },
  [RolodexEntryType.PIPE_WRAP]: {
    shortName: 'Pipe Wrap',
    longName: 'Pipe Wrap',
    description:
      'A plan to wrap a pipe component in a protective material to increase stress tolerance',
  },
  [RolodexEntryType.REPLACEMENT_PLAN]: {
    shortName: 'Component Replacement',
    longName: 'Component Replacement',
    description: 'A plan to completely replace the component',
  },
}

export const CHP_ACTION_ENTRY_TYPES = Object.keys(
  ENTRY_TYPE_TO_CHP_ACTION_TYPE
) as RolodexEntryType[]

/**
 * Used to access ENTRY_TYPE_TO_CHP_ACTION_TYPE values even if they key is any type
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function getChpActionTypeByKey(
  key: any
): ComponentHealthPlanActionType | undefined {
  if (key in ENTRY_TYPE_TO_CHP_ACTION_TYPE) {
    return ENTRY_TYPE_TO_CHP_ACTION_TYPE[key as RolodexEntryType]
  }
  return undefined
}

// TODO: Abstract this out to an entry to make it easily configurable
export const RlScore = {
  [ComponentHealthCondition.VeryPoor]: 0,
  [ComponentHealthCondition.Bad]: 25,
  [ComponentHealthCondition.Fair]: 75,
  [ComponentHealthCondition.Excellent]: 100,
}

// TODO: Abstract this out to an entry to make it easily configurable
export const CriticalityScore = {
  '1': 100,
  '2': 75,
  '3': 50,
  '4': 25,
  '5': 0,
}

// TODO: Abstract this out to an entry to make it easily configurable
export const riskScoreWeights = {
  remainingLife: 0.6,
  criticality: 0.4,
}

export const DEFAULT_TIME_HORIZON_YEARS = 10

export const DEFAULT_DAMAGE_AREAS_PLAN_KEY = 'baseData'
